export const storage = {
    exercises: '/Exercises',
    tasks: '/Exercises/Tasks',
    options: '/Exercises/Tasks/Options',
    missions: '/Missions',
    stages: '/Missions/Stages',
    skills: '/Skills',
    newsAndEvents: '/Content/NewsAndEvents',
    externalContent: '/ExternalContent',
    rewards: '/Rewards',
    coach: '/Coach',
};
